import apiClient from '../client';
import { TransactionDetail } from '../../../types/api';

export interface TransactionFilters {
  customerId?: number;
  transactionType?: 'deposit' | 'usage';
  startDate?: string;
  endDate?: string;
  search?: string;
  skip?: number;
  limit?: number;
  includeCancelled?: boolean;
}

export interface TransactionCancelRequest {
  reason: string;
}

export interface RefundCreateRequest {
  amount: number;
  reason: string;
}

export const transactionApi = {
  // 取引履歴を取得
  getTransactions: async (filters: TransactionFilters = {}): Promise<TransactionDetail[]> => {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        // camelCase を snake_case に変換
        const snakeKey = key.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
        params.append(snakeKey, value.toString());
      }
    });

    const endpoint = params.toString() ? `/transactions?${params}` : '/transactions';
    return apiClient.get<TransactionDetail[]>(endpoint);
  },

  // 取引詳細を取得
  getTransaction: async (transactionId: string): Promise<TransactionDetail> => {
    return apiClient.get<TransactionDetail>(`/transactions/${transactionId}`);
  },

  // 取引をキャンセル
  cancelTransaction: async (
    transactionId: string,
    request: TransactionCancelRequest
  ): Promise<TransactionDetail> => {
    return apiClient.post<TransactionDetail>(`/transactions/${transactionId}/cancel`, request);
  }
};
